import React, { useEffect, useState } from 'react';
import AuthLayout from '../auth-layout';
import useLetsGetStartedContext from 'contexts/lets-get-started.context';
import { Input } from '@cokitchen/cokitchen-components';

type CreateFormType = {
  password: string;
  confirm_password: string;
};
const CreatePassword = () => {
  const { passwordFormData, setPasswordFormData, setDisabled } = useLetsGetStartedContext();
  const [formError, setFormError] = useState<Partial<CreateFormType>>({});

  const formIsValid = (): boolean => {
    setFormError({});
    if (passwordFormData.password === passwordFormData.confirm_password) return true;
    if (passwordFormData.password === '')
      setFormError({ ...formError, password: 'Password is required' });
    if (passwordFormData.confirm_password === '')
      setFormError({ ...formError, confirm_password: 'Confirm Password is required' });

    if (passwordFormData.password !== passwordFormData.confirm_password) {
      setFormError(() => ({
        confirm_password: 'Passswords dont match',
        password: 'Passwords dont match'
      }));
    }
    return false;
  };

  const updateFormData = (name: string, value: string) => {
    setPasswordFormData({ ...passwordFormData, [name]: value });
  };

  const handleConfirm = async () => {
    if (!formIsValid()) return;
  };

  useEffect(() => {
    const { password, confirm_password } = passwordFormData;
    if (password && confirm_password) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [passwordFormData]);
  return (
    <div>
      <AuthLayout
        onConfirm={handleConfirm}
        title={'Create a password'}
        subtitle={`Enter your preferred password`}
        hideButton>
        <div className='flex flex-col gap-7'>
          <Input
            design='bordered'
            placeholder='Password'
            label='Password'
            type='password'
            value={passwordFormData.password}
            error={formError.password}
            onChange={(e) => updateFormData('password', e.target.value)}
            name='password'
          />
          <Input
            design='bordered'
            placeholder='Confirm Password'
            label='Confirm Password'
            type='password'
            error={formError.confirm_password}
            value={passwordFormData.confirm_password}
            onChange={(e) => updateFormData('confirm_password', e.target.value)}
            name='confirm_password'
          />
        </div>
      </AuthLayout>
    </div>
  );
};

export default CreatePassword;
